import { State } from 'src/types'
import { hamidashiOfNormal } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/hamidashi/normal'
import { middleFingerLeft, middleFingerRight } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/ringFinger'
import { indexFingerLeft, indexFingerRight } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/indexFinger'
import { littleFingerLeft, littleFingerRight } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/littleFinger'
import { thumbAndListBelt, thumbOut } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/thumbAndListBelt'
import { listBelt } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/listBelt'
import { indexFingerPad } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/fingerCoverOrPad/indexFingerPad'
import { fingerCrotch } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/fingerCrotch'
import { catchFace2 } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/catchFace2'
import { edgeOfBeltBackStyle } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/edge/edgeOfBeltBackstyle'
import { edgeOfWrist } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/edge/edgeOfWrist'
import {
  startInversion,
  thumbEmbroideryDrawerLeftThrow,
  thumbLeftEmbroideryDrawerLeftThrow,
  thumbRightEmbroideryDrawerLeftThrow,
  undoInversion
} from 'src/util/canvas'
import { pitcherDesign } from '../../../rightThrow/back/backStyles/pitcherDesign'

const getFingerGuardPositionCoordinate = (position: string) => {
  switch (position) {
    case 'onIndex':
      return { x: 0, y: 0, numerator: 0 }
    case 'onIndexLeft':
      return { x: -30, y: 24, numerator: -3 }
    case 'onFingerCrotch':
      return { x: -65, y: 40, numerator: -5 }
    case 'onMiddleRight':
      return { x: -110, y: 63, numerator: -9 }
    case 'onMiddle':
      return { x: -170, y: 92, numerator: -15 }
    default:
      return { x: 0, y: 0, numerator: 0 }
  }
}

// 通常ベルトモデル
export const beltBackStyleDrawerLeftThrow = (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean, canvasWidth: number): void => {
  if (['crownBackStyle', 'firstBackStyle'].includes(state.backStyle?.value)) return
  if (['crownBackStyle', 'firstBackStyle'].includes(state.baseModel?.backStyle)) return
  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)

  startInversion(ctx, canvasWidth)
  // 親指指袋_手口ベルト(下地)
  thumbAndListBelt(ctx, state.thumbWeb?.color, state.stitch?.color)
  const isPitcher = state.baseModel.position === 'pitcher'
  if (isPitcher) {
    pitcherDesign(ctx, state, 0, 0)
  }
  thumbOut(ctx, state.thumbOut?.color) // 親指＿外

  // 人差し指＿右... UBackここで描いてる
  indexFingerRight(
    ctx,
    state,
    // needCatchFaceWrap ? state.indexWeb?.color : state?.thumbWebAndIndexWeb?.color,
    // state.catchFace.color,
    // state.hamidashi.color,
    needCatchFaceWrap
  )

  const isBelt = ['normal', 'unselected', undefined].includes(state.beltType?.value)
  if (isBelt && !isPitcher) {
    listBelt(ctx, state.listBelt?.color, state.stitch?.color)
  }

  // 人差し指＿左
  indexFingerLeft(ctx, state.indexMiddle?.color)
  // 中指＿右
  middleFingerRight(ctx, state.middleIndex?.color)
  // 中指＿左
  middleFingerLeft(ctx, state.leatherIntegratedMiddle?.value === 'none' ? state.middleRing?.color : state.middleIndex?.color)
  // 薬指＿右
  ringFingerRight(ctx, state.ringMiddle?.color)
  // 薬指＿左
  ringFingerLeft(ctx, state.ringLittle?.color)

  // 小指＿右
  littleFingerRight(ctx, state.littleRing?.color)
  // 小指＿左
  littleFingerLeft(ctx, state.littleOut?.color)
  // ハミダシ
  const isSUN01W = state.baseModel?.productNumber === 'SUN-01W'
  hamidashiOfNormal(ctx, state.hamidashi?.color, state.leatherIntegratedMiddle, state?.middleIndex?.color, isSUN01W, state.littleRing.color)

  // 捕球面 / ウェブ下折り返し
  catchFace2(ctx, state.catchFace?.color, state.stitch?.color, needCatchFaceWrap)
  // ヘリ革

  // 指股
  if (state?.backStyle?.value !== 'crownBackStyle') {
    fingerCrotch(ctx, state.catchFace?.color, state.hamidashi?.color, state.baseModel?.isFingerCrotch)
  }

  // 指当て(人指し指)
  const { x, y, numerator } = getFingerGuardPositionCoordinate(state.fingerGuardPosition?.value)
  isIndexFingerPad && indexFingerPad(ctx, state.indexCover.color, state.stitch.color, x, y, numerator)

  // thumbOverではなかったら
  edgeOfBeltBackStyle(ctx, state.edge?.color, state.stitch?.color)
  edgeOfWrist(ctx, state.edge?.color, state.stitch?.color)

  undoInversion(ctx, canvasWidth)
  thumbEmbroideryDrawerLeftThrow(ctx, state.embroideries, state.backStyle)
  thumbLeftEmbroideryDrawerLeftThrow(ctx, state.embroideries)
  thumbRightEmbroideryDrawerLeftThrow(ctx, state.embroideries)
}
